import type { ButtonProps } from "antd";

import { StyledFloatingActionButton } from "./Styled";

interface FloatingActionButtonProps extends ButtonProps {
    top?: number;
    right?: number;
    left?: number;
    bottom?: number;
    btnSize?: number;
    zIndex?: number;
    bgColor?: "success" | "error";
    iconSize?: number;
}

export const FloatingActionButton = ({
    top,
    right,
    left,
    bottom,
    btnSize = 50,
    zIndex = 0,
    bgColor = "success",
    iconSize = 28,
    ...props
}: FloatingActionButtonProps) => {
    return (
        <StyledFloatingActionButton
            $top={top}
            $bottom={bottom}
            $right={right}
            $left={left}
            $size={btnSize}
            $zIndex={zIndex}
            $bgColor={bgColor}
            $iconSize={iconSize}
            type={"primary"}
            {...props}
        />
    );
};
